/**
 * Yellow / red % off the selected plan target. Tenant defaults or an explicit KPI override.
 */

import React from 'react';

export interface ThresholdDraft {
  yellowOffPct: string;
  redOffPct: string;
}

interface KpiThresholdFieldsProps {
  draft: ThresholdDraft;
  onChange: (next: ThresholdDraft) => void;
  disabled?: boolean;
  t: (key: string) => string;
}

export function parseThresholdDraft(draft: ThresholdDraft): { yellowOffPct: number; redOffPct: number } | null {
  const yellow = draft.yellowOffPct.trim() === '' ? NaN : Number(draft.yellowOffPct);
  const red = draft.redOffPct.trim() === '' ? NaN : Number(draft.redOffPct);
  if (!Number.isFinite(yellow) || !Number.isFinite(red)) return null;
  if (yellow < 0 || red < 0 || yellow > 100 || red > 100 || yellow > red) return null;
  return { yellowOffPct: yellow, redOffPct: red };
}

export const KpiThresholdFields: React.FC<KpiThresholdFieldsProps> = ({ draft, onChange, disabled, t }) => (
  <div className="grid grid-cols-2 gap-2">
    <label className="block min-w-0">
      <span className="block text-[10px] text-[var(--color-secondary-text)] mb-0.5">
        {t('kpi.thresholdYellow') || 'Yellow at % off'}
      </span>
      <input
        type="number"
        min={0}
        max={100}
        step={1}
        disabled={disabled}
        value={draft.yellowOffPct}
        onChange={(event) => onChange({ ...draft, yellowOffPct: event.target.value })}
        className="w-full text-[11px] px-1.5 py-0.5 border border-[var(--color-border)] rounded bg-[var(--color-surface)] text-[var(--color-surface-text)]"
      />
    </label>
    <label className="block min-w-0">
      <span className="block text-[10px] text-[var(--color-secondary-text)] mb-0.5">
        {t('kpi.thresholdRed') || 'Red at % off'}
      </span>
      <input
        type="number"
        min={0}
        max={100}
        step={1}
        disabled={disabled}
        value={draft.redOffPct}
        onChange={(event) => onChange({ ...draft, redOffPct: event.target.value })}
        className="w-full text-[11px] px-1.5 py-0.5 border border-[var(--color-border)] rounded bg-[var(--color-surface)] text-[var(--color-surface-text)]"
      />
    </label>
  </div>
);
